






















import { Component, Prop, Vue } from 'vue-property-decorator';

export enum BtnColor {
    Default = '',
    Primary = 'button--primary-color',
    Secondary = 'button--secondary-color',
    BlueDark = 'button--blue-dark-color',
    Transparent = 'button--transparent-color',
    Action = 'button--action-color',
    BlueSuperDark = 'button--blue-super-dark',
    GreenMiddle = 'button--green-middle-color',
    Red = 'button--red-color',
    Orange = 'button--orange-color',
    Black = 'button--black-color',
    Purple = 'button--purple-color',
    LightGreen = 'button--light-green',
}

export enum BtnHeight {
    Large = 'button--large-height',
}

export enum BtnWidth {
    Auto = 'button--auto-width',
    Small = 'button--small-width',
    Medium = 'button--medium-width',
    Large = 'button--large-width',
    Max = 'button--max-width',
}

export enum BtnPredefinedStyle {
    Simple = 'button--simple',
    Activable = 'button--activable',
    ActivableNotFill = 'button--activable-not-fill',
    icon = 'button--icon',
    Octosquare = 'button--octosquare',
}

export enum BtnFontSize {
    Sm = 'button--fs-sm',
    Md = 'button--fs-md',
    Lg = 'button--fs-lg',
}

@Component
export default class Btn extends Vue {
    @Prop() private text!: string;
    @Prop({ default: false }) private disabled!: boolean;
    @Prop({ default: false }) private flat!: boolean;
    @Prop({ default: false }) private expanded!: boolean;
    @Prop({ default: BtnColor.Default }) private btnBackgroundColor!: BtnColor;
    @Prop({ default: BtnWidth.Small }) private btnWidth!: BtnWidth;
    @Prop({ default: null }) private btnHeight!: BtnHeight;
    @Prop({ default: BtnFontSize.Sm }) private btnFontSize!: BtnFontSize;
    @Prop({ default: BtnPredefinedStyle.Simple })
    private btnPredefinedStyle!: BtnPredefinedStyle;
    @Prop({ default: false }) private active!: boolean;

    private expandedClassObject = {
        'button--expanded': this.expanded,
    };

    // METHODS
    private emitClick() {
        if (!this.disabled) {
            this.$emit('btn-clicked');
        }
    }
}
